import { Progress } from "@/components/Progress/Progress";
import { cn } from "@/lib/cn";
import { defaultNS, useTranslation } from "@/lib/i18n";

import {
  getFilledFieldCount,
  getFilledRequiredFieldCount,
  getRequiredFieldCount,
  getTotalFieldCount,
} from "../../store/selectors/form-selectors";
import type { FormStore } from "../../store/types";
import { useFormStoreContext } from "../../store/zustand-context";

interface FormProgressProps {
  className?: string;
}

/**
 * フォーム完了進捗を表示するコンポーネント
 */
export const FormProgress = ({ className }: FormProgressProps) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "features.formFactory",
  });
  const store: FormStore = useFormStoreContext();

  // フォーム全体のフィールドの総数と入力済み数を計算
  const totalFieldCount = getTotalFieldCount(store);
  const filledFieldCount = getFilledFieldCount(store);

  // 必須フィールドの総数と入力済み数を計算
  const requiredTotal = getRequiredFieldCount(store);
  const requiredFilled = getFilledRequiredFieldCount(store);

  return (
    <div className={cn("mb-4", className)}>
      <Progress
        label={t("progressLabels.progress")}
        completed={filledFieldCount}
        total={totalFieldCount}
      />
      <Progress
        label={t("progressLabels.required")}
        completed={requiredFilled}
        total={requiredTotal}
      />
    </div>
  );
};
